import React from 'react';
import PropTypes from 'prop-types';

function SurveyIcon({ id }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0"
      y="0"
      enableBackground="new 0 0 91 91"
      version="1.1"
      viewBox="0 0 91 91"
      xmlSpace="preserve"
      role="img"
      aria-labelledby="survey-icon-title"
    >
      <title id="survey-icon-title">Survey Icon</title>
      <g>
        <g transform="translate(6 4)">
          <g>
            <linearGradient
              id={`path-2_2_${id}`}
              x1="-428.666"
              x2="-428.666"
              y1="319.596"
              y2="317.776"
              gradientTransform="matrix(50 0 0 -50 21472.815 15975.786)"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0" className="startColor" />
              <stop offset="1" className="endColor" />
            </linearGradient>
            <circle
              cx="39.5"
              cy="41.5"
              r="45.5"
              fill={`url(#path-2_2_${id})`}
            />
          </g>
          <g transform="translate(13 11)">
            <g>
              <g>
                <path fill="#FFF" d="M5.8 5.6L47.2 5.6 47.2 55.4 5.8 55.4z" />
                <path
                  fill="#EBEBEB"
                  d="M26.5 5.6L47.2 5.6 47.2 55.4 26.5 55.4z"
                />
                <g fill="#A0B9D8" transform="translate(13.823 3.063)">
                  <path d="M16 7.5L28.4 7.5 28.4 11.7 16 11.7z" />
                  <path d="M16 15L22.3 15 22.3 19.1 16 19.1z" />
                  <path d="M16 21.6L28.4 21.6 28.4 25.8 16 25.8z" />
                  <path d="M16 29.1L22.3 29.1 22.3 33.2 16 33.2z" />
                </g>
                <path
                  fill="#EBEBEB"
                  d="M10.8 10.6L23.2 10.6 23.2 22.2 10.8 22.2z"
                />
                <path
                  fill="#EBEBEB"
                  d="M10.8 24.7L23.2 24.7 23.2 36.3 10.8 36.3z"
                />
                <path
                  fill="#EBEBEB"
                  d="M10.8 38.8L23.2 38.8 23.2 50.4 10.8 50.4z"
                />
                <path
                  fill="#A0B9D8"
                  d="M29.8 38.8L42.3 38.8 42.3 42.9 29.8 42.9z"
                />
                <path
                  fill="#A0B9D8"
                  d="M29.8 46.3L36.1 46.3 36.1 50.4 29.8 50.4z"
                />
                <path
                  fill="#FF6680"
                  d="M21.7 14.1L19.3 11.7 17 14.1 14.6 11.7 12.3 14.1 14.6 16.4 12.3 18.7 14.6 21.1 17 18.7 19.3 21.1 21.7 18.7 19.3 16.4z"
                />
                <path
                  fill="#FF6680"
                  d="M21.7 42.3L19.3 39.9 17 42.3 14.6 39.9 12.3 42.3 14.6 44.6 12.3 46.9 14.6 49.3 17 46.9 19.3 49.3 21.7 46.9 19.3 44.6z"
                />
                <path
                  fill="#45E595"
                  d="M16.2 30.2L20.3 26.1 22.6 28.4 16.2 34.9 11.4 30.1 13.7 27.8z"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

SurveyIcon.propTypes = {
  id: PropTypes.string,
};

SurveyIcon.defaultProps = {
  id: '',
};

export default React.memo(SurveyIcon);
